import type { AxiosError, AxiosInstance } from 'axios';
import * as cancellation from './cancellation.js';
import type { WorkspaceGlobalSearch } from './interfaces/workspace.global-search.js';
import * as xform from './transformers/index.js';

export class WorkspacesGlobalSearchClient {
  constructor(private authenticatedClient: AxiosInstance) { }

  bar = (data: WorkspaceGlobalSearch.Bar.Request) => {
    return this.authenticatedClient.post<WorkspaceGlobalSearch.Bar.Response>(`/workspaces/global-search/bar`, {
      query: data.query,
      filters: data.filters,
    }, { cancelToken: data.cancelToken })
      .catch<void>((e: AxiosError) => cancellation.ignoreRequestCancellationError(e as any));
  };

  files = (data: WorkspaceGlobalSearch.Files.Request): Promise<WorkspaceGlobalSearch.Files.Response> => {
    return this.authenticatedClient.post(`/workspaces/global-search/files`, {
      filters: data.filters,
      size: data.size,
    }).then(({ data }) => xform.normalizeSearchFullFileResults(data)!);
  };

  folders = (data: WorkspaceGlobalSearch.Folders.Request): Promise<WorkspaceGlobalSearch.Folders.Response> => {
    return this.authenticatedClient.post(`/workspaces/global-search/folders`, {
      filters: data.filters,
      size: data.size,
    }).then(({ data }) => xform.normalizeSearchFullFolderResults(data)!);
  };

  brands = (data: WorkspaceGlobalSearch.Brands.Request): Promise<WorkspaceGlobalSearch.Brands.Response> => {
    return this.authenticatedClient.post(`/workspaces/global-search/brands`, {
      filters: data.filters,
      size: data.size,
    }).then(({ data }) => xform.normalizeSearchFullBrandResults(data)!);
  };

  dashboards = (data: WorkspaceGlobalSearch.Dashboards.Request): Promise<WorkspaceGlobalSearch.Dashboards.Response> => {
    return this.authenticatedClient.post(`/workspaces/global-search/dashboards`, {
      filters: data.filters,
      size: data.size,
    }).then(({ data }) => xform.normalizeSearchFullDashboardResults(data)!);
  };

  quantanalyses = (data: WorkspaceGlobalSearch.QuantAnalyses.Request): Promise<WorkspaceGlobalSearch.QuantAnalyses.Response> => {
    return this.authenticatedClient.post(`/workspaces/global-search/quant-analyses`, {
      filters: data.filters,
      size: data.size,
    }).then(({ data }) => xform.normalizeSearchFullQuantAnalysesResults(data)!);
  };

  projects = (data: WorkspaceGlobalSearch.Projects.Request): Promise<WorkspaceGlobalSearch.Projects.Response> => {
    return this.authenticatedClient.post(`/workspaces/global-search/projects`, {
      filters: data.filters,
      size: data.size,
    }).then(({ data }) => xform.normalizeSearchFullProjectResults(data)!);
  };

  transcripts = (data: WorkspaceGlobalSearch.Transcripts.Request): Promise<WorkspaceGlobalSearch.Transcripts.Response> => {
    return this.authenticatedClient.post(`/workspaces/global-search/transcripts`, {
      filters: data.filters,
      size: data.size,
    }).then(({ data }) => xform.normalizeSearchFullTranscriptResults(data)!);
  };
}

export default WorkspacesGlobalSearchClient;